import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

export const ScrollToTop = (props: any) => {
  const location = useLocation();
  useEffect(() => {
    const excludedRoute = location.pathname.includes('/product/productsearch');
    if (!excludedRoute) {
      setTimeout(() => {
        document
          .querySelector('#main-view')
          ?.scrollTo({ behavior: 'smooth', top: 0 });
      }, 500);
    }
  }, [location.pathname]);

  return <>{props.children}</>;
};
